import { render } from "./BudgetEstimator.vue?vue&type=template&id=34d8fb2a&scoped=true"
import script from "./BudgetEstimator.vue?vue&type=script&lang=js"
export * from "./BudgetEstimator.vue?vue&type=script&lang=js"

import "./BudgetEstimator.vue?vue&type=style&index=0&id=34d8fb2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8fb2a"]])

export default __exports__